/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/SavedItems',[
    'jquery',
    'modules/Cart/all',
    'global/all'
], function ($, Cart, Roc) {
    'use strict';

    var targetSelector = '#cartSavedItems';
    var viewModel = {};

    /* Helpers UI */

    function showEmptyResultsMsg() {
        Roc.UI.template('#noEntryMsg-Tmp', { message: 'You have no saved items.' }).then(function (renderedTemplate) {
            $(renderedTemplate).insertBefore(targetSelector);
        });
    }

    function checkEmptyResultsMsg() {
        if ($(targetSelector + ' .itemWrapper').length === 0) {
            showEmptyResultsMsg();
        }
    }

    /* Events */

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, checkEmptyResultsMsg);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, checkEmptyResultsMsg);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_SAVED_ITEM, checkEmptyResultsMsg);
    }

    /* Init */

    function init(initData) {
        viewModel = initData;
        //viewModel.isMyAccount = true;
        Cart.CartSavedItems.init(viewModel);
        $(targetSelector).show();       
        if (!viewModel || !viewModel.savedItems || viewModel.savedItems.length === 0) {
            showEmptyResultsMsg();
        }
        bindEvents();
    };

    var SavedItems = {
        init: init
    };

    Roc.Logger.debug('SavedItems.js Loaded:', SavedItems);

    return SavedItems;
});

